import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { Button, Icon, Spinner } from '@gsa/afp-component-library';
import { SET_BILINDE_ATTACHMENTS_ORDER } from '../provider/queries';
import { useBidLineDetails } from '../provider/bid-line-details-provider';

const ImageOrderUpDown = ({ rows, row }) => {
  const isFirstRow = row.id === '0';
  const isLastRow = row.id === String(rows.length - 1);
  const { reloadBidLineDocuments } = useBidLineDetails();
  const [movingType, setMovingType] = useState(null);

  const [setBidLineAttachmentsOrder, { loading }] = useMutation(
    SET_BILINDE_ATTACHMENTS_ORDER,
    {
      onCompleted: () => {
        reloadBidLineDocuments();
        setMovingType(null);
      },
      onError: () => {
        setMovingType(null);
      },
    },
  );

  const orderedIds = rows.map((r) =>
    parseInt(r.original.bidLineAttachmentId, 10),
  );

  const moveUp = (attachmentId) => {
    const currentIndex = orderedIds.indexOf(parseInt(attachmentId, 10));
    if (currentIndex === 0) return;
    const newOrderedIds = [...orderedIds];
    const temp = newOrderedIds[currentIndex - 1];
    newOrderedIds[currentIndex - 1] = newOrderedIds[currentIndex];
    newOrderedIds[currentIndex] = temp;
    setMovingType('up');
    setBidLineAttachmentsOrder({
      variables: {
        bideLineId: parseInt(row.original.bidLineId, 10),
        orderedAttachmentIds: newOrderedIds,
      },
    });
  };

  const moveDown = (attachmentId) => {
    const currentIndex = orderedIds.indexOf(parseInt(attachmentId, 10));
    if (currentIndex === orderedIds.length - 1) return;
    const newOrderedIds = [...orderedIds];
    const temp = newOrderedIds[currentIndex + 1];
    newOrderedIds[currentIndex + 1] = newOrderedIds[currentIndex];
    newOrderedIds[currentIndex] = temp;
    setMovingType('down');
    setBidLineAttachmentsOrder({
      variables: {
        bideLineId: parseInt(row.original.bidLineId, 10),
        orderedAttachmentIds: newOrderedIds,
      },
    });
  };

  if (rows.length === 1) return null;

  return (
    <div className="margin-1" style={{ minWidth: 96 }}>
      {isLastRow ? (
        <div style={{ width: 56, display: 'inline-block' }} />
      ) : (
        <Button
          data-testid="move-down"
          variant="unstyled"
          aria-label="Move image down"
          className="margin-right-2"
          disabled={loading}
          onClick={() => moveDown(row.original.bidLineAttachmentId, 10)}
          onKeyDown={(evt) => {
            if (evt.key === 'Enter') {
              moveDown(row.original.bidLineAttachmentId);
            }
          }}
          label={
            <div
              style={{
                width: 40,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {loading && movingType === 'down' ? (
                <Spinner size="small" />
              ) : (
                <Icon iconName="arrow_downward" style={{ color: 'black' }} />
              )}
            </div>
          }
        />
      )}
      {isFirstRow ? null : (
        <Button
          variant="unstyled"
          data-testid="move-up"
          disabled={loading}
          aria-label="Move image up"
          onClick={() => moveUp(row.original.bidLineAttachmentId)}
          onKeyPress={(evt) => {
            if (evt.key === 'Enter') {
              moveUp(row.original.bidLineAttachmentId);
            }
          }}
          label={
            <div
              style={{
                width: 40,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {loading && movingType === 'up' ? (
                <Spinner size="small" />
              ) : (
                <Icon iconName="arrow_upward" style={{ color: 'black' }} />
              )}
            </div>
          }
        />
      )}
    </div>
  );
};

ImageOrderUpDown.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    original: PropTypes.shape({
      bidLineAttachmentId: PropTypes.string.isRequired,
      bidLineId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ImageOrderUpDown;
